module.exports = __webpack_public_path__ + "2d714411cd2c71f6850bb664652dda52.svg";